import { render, staticRenderFns } from "./leftChart.vue?vue&type=template&id=05127f6a&scoped=true&"
import script from "./leftChart.vue?vue&type=script&lang=js&"
export * from "./leftChart.vue?vue&type=script&lang=js&"
import style0 from "./leftChart.vue?vue&type=style&index=0&id=05127f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05127f6a",
  null
  
)

export default component.exports